module.exports = __webpack_public_path__ + "static/17_norsk-d4ed3e1941aff86158d28d6cca635183.png";